module.exports = __webpack_public_path__ + "media/background.6f8d126e.ogg";